import { Controller } from "stimulus"

import $ from "jquery"

const ALL_PROVIDERS = "all"

export default class extends Controller {
  connect() {
    this.handleChange = this.handleChange.bind(this)
    $(this.element).on("change.providerSelect", this.handleChange)
  }

  disconnect() {
    $(this.element).off("change.providerSelect", this.handleChange)
  }

  handleChange() {
    if (!this.selectedValues().includes(ALL_PROVIDERS)) return

    Array.from(this.element.options).forEach((option) => {
      option.selected = false
    })

    $(this.element).trigger("change.select2")
  }

  selectedValues() {
    return Array.from(this.element.selectedOptions).map((option) => option.value)
  }
}
